import { Component, Emit, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import DsModal from '@/shared/modal/ds-modal.vue';
import PublicService from '@/service/public.service';
import psl, { ParsedDomain } from 'psl';

interface ChannelData {
  channelId: string;
  channelName: string;
  channelDescription: string;
  channelImageUri: string;
  numberRegister: number;
  channelType: string;
  allowAccess: string;
  accounts: {
    accountId: any;
    accountName: string;
    dataSource: {
      dataSourceType: string;
      msKeyword: string;
    };
    password: string;
    isScrap: boolean;
  }[];
}

@Component({
  components: { DsModal },
})
export default class ScrapAgentModalChannelRegisterUrlForm extends Vue {
  @Prop({ type: Boolean, default: false }) open!: boolean;
  @Prop({ type: Array, default: () => [] }) listChannels!: ChannelData[];
  @Prop({ type: Array, required: false }) sourceCacheList!: any;
  localListChannels: ChannelData[] = [...this.listChannels];
  @Inject('publicService')
  public publicService: () => PublicService;
  showModal: boolean = this.open;
  debounceTimer: any;
  id: string | null = null;
  isCheckUrl = false;
  formData = {
    url: '',
    chanelName: '',
    channelIntro: '',
    registerAccount: false,
    id: '',
    password: '',
    image: '',
    favicon: '',
    writer: [],
  };
  isLoading = false;
  isDisableBtn = true;

  @Watch('open')
  onOpenChange(value: boolean) {
    console.log('show-modal', value);
    this.showModal = value;
    this.isDisableBtn = false;
    if (value) {
      this.isCheckUrl = false;
      this.formData = {
        url: '',
        chanelName: '',
        channelIntro: '',
        registerAccount: false,
        id: '',
        password: '',
        image: '',
        favicon: '',
        writer: [],
      };
    }
    if (this.sourceCacheList.length > 0) {
      console.log(this.sourceCacheList, 'sourceCacheList');
      const matchedChannel = this.sourceCacheList.find(channel => channel.channelType === 'URL');

      if (matchedChannel) {
        const dataSources = matchedChannel.accounts[0].dataSource;
        dataSources.forEach(ds => {
          if (ds.dataSourceTypes[0] === 'URL') {
            this.formData.url = ds.value[0];
            setTimeout(async () => {
              await this.handleCheckUrl({
                url: this.formData.url,
                lang: localStorage.getItem('currentLanguage'),
              });
            }, 700);
          }
        });
      }
    }
  }

  @Watch('isLoading', { deep: true })
  checkingLoading(value: any) {
    if (value == true) {
      this.formData.chanelName = '';
      this.formData.channelIntro = '';
    }
  }
  // @Watch('formData', { deep: true })
  // checkingValid(value: any) {
  //   if (!value.url || value.url.trim() === '' || value.chanelName.trim() === '' || value.channelIntro.trim() === '') {
  //     this.isDisableBtn = true;
  //     return;
  //   }
  //   this.isDisableBtn = false;
  // }

  @Watch('formData', { deep: true })
  async handle(newUrl: any) {
    if (!newUrl.url || newUrl.url.trim() === '' || this.isCheckUrl === false || this.isLoading === true) {
      this.isDisableBtn = true;
    } else {
      this.isDisableBtn = false;
    }
  }

  async handleEnter() {
    if (!this.formData.url) return;
    if (this.formData.url.startsWith('http://')) {
      this.formData.url = this.formData.url.replace('http://', 'https://');
    } else if (!this.formData.url.startsWith('https://')) {
      this.formData.url = 'https://' + this.formData.url;
    }
    await this.handleCheckUrl({
      url: this.formData.url,
      lang: localStorage.getItem('currentLanguage'),
    });
  }

  async handleCheckUrl(data) {
    this.isLoading = true;
    try {
      const res = await this.publicService().previewInfoByUrlV3(data);
      if (res.data) {
        const parsedUrl = new URL(res.data.domain);
        const parsed = psl.parse(parsedUrl.host);
        if ((parsed as ParsedDomain).sld) {
          this.formData.chanelName = (parsed as ParsedDomain).sld;
        }
        // this.formData.url = res.data.url;
        // this.formData.chanelName = res.data.title;
        this.formData.channelIntro = res.data.desc;
        this.formData.image = res.data.image;
        this.formData.favicon = res.data.favicon;
        this.formData.writer = Array.isArray(res.data.author) ? res.data.author : [res.data.author];
        this.isCheckUrl = true;
      }
    } catch (error) {
      console.error('Error fetching preview info:', error);
      this.isLoading = false;
    } finally {
      this.isLoading = false;
    }
  }

  @Emit('modal:close')
  handleClose() {
    this.showModal = false;
    this.formData = {
      url: '',
      chanelName: '',
      channelIntro: '',
      registerAccount: false,
      id: '',
      password: '',
      image: '',
      favicon: '',
      writer: [],
    };
  }

  async handleSubmit() {
    // if (!this.formData || !this.formData.chanelName) {
    //   console.error('form data not valid!');
    //   return;
    // }

    const documentInfo = this.buildDocumentInfo();
    const accountId = null;
    const data: any = {
      channelId: null,
      channelName: 'URL',
      channelDescription: this.formData.channelIntro || '',
      channelImageUri: 'https://dzh91b51qfr7r.cloudfront.net/social-channel-thumb/url.png',
      // channelImageUri: this.formData.image,
      numberRegister: this.formData.id ? 1 : 0,
      channelType: 'URL',
      allowAccess: 'true',
      accounts: [
        {
          accountId: accountId,
          accountName: this.formData.id || '-',
          dataSource: [
            {
              dataSourceTypes: ['URL'],
              value: [this.formData.url],
              documentInfo: documentInfo,
            },
          ],
          isScrap: true,
        },
      ],
    };
    this.$emit('addItem', data);
    this.handleClose();
  }

  // New helper method to build the documentInfo object
  private buildDocumentInfo(): any {
    const localUser = JSON.parse(localStorage.getItem('localStorageUser') || '{}');
    return {
      requestId: `u_src_${Date.now().toString()}`,
      title: this.formData.chanelName,
      path: this.formData.url,
      description: this.formData.channelIntro || '',
      content: '',
      type: 'URL',
      collector: '',
      createdAt: new Date().toISOString(),
      userKey: localUser?.id || '',
      writer: this.formData.writer,
      author: '',
      originDate: '',
      searchType: 'WEB',
      search_type: ['WEB'] as string[],
      mediaType: ['WEB'] as string[],
      image_uri: [] as string[],
      image_uri_thumbnail: '',
      favicon: this.formData.favicon,
      lang: localStorage.getItem('currentLanguage') || 'en',
      liked: 0,
      keyword: null,
      _ml_entity: [] as string[],
      _ml_entity_search: [] as string[],
      requestBy: 'USER',
      parentDocId: '',
      parent_doc_id: [] as string[],
      forcedClustering: false,
      requestedResourceList: [] as string[],
      targetBpId: '',
      titleBriefingPage: '',
      isFeed: false,
      html_raw: '',
      published_at: new Date().toISOString(),
      service_html: '',
      owner_user_key: '',
      sameBriefingPage: false,
      docType: 11,
      isInsideGroup: false,
      isGroup: false,
      originType: 'SCRAPE',
      chunkId: '',
      chunkText: '',
    };
  }
}
